import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TelaDeLiberacaoRoutingModule } from './tela-de-liberacao-routing.module';
import { TelaDeLiberarComponent } from './tela-de-liberar.component';
import { TelaDeLiberacaoComponent } from './tela-de-liberacao';
import { BrowserModule } from '@angular/platform-browser';
import { NgbCollapseModule, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FileUploadModule } from 'ng2-file-upload';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    TelaDeLiberarComponent,
    TelaDeLiberacaoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModalModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    AutocompleteLibModule,
    NgbCollapseModule,
    Ng2SearchPipeModule,
    TelaDeLiberacaoRoutingModule
  ]
})
export class TelaDeLiberacaoModule { }
